(function () {
  'use strict';

  if (typeof Vue === 'undefined') {
    console.warn('[slideout-cart] Vue 2 is not loaded.');
    return;
  }

  // Intercept ALL fetch calls to /cart/add.js globally, regardless of source
  var _nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method || 'GET').toUpperCase();
    var isCartAdd = url.indexOf('/cart/add') !== -1 && method === 'POST';
    var promise = _nativeFetch.apply(this, arguments);
    if (isCartAdd) {
      promise.then(function (res) {
        if (res.ok) {
          var clone = res.clone();
          clone.json().then(function (addedItem) {
            document.dispatchEvent(new CustomEvent('slideout-cart:item-added', { detail: { item: addedItem } }));
          }).catch(function () {
            document.dispatchEvent(new CustomEvent('slideout-cart:item-added'));
          });
        }
        return res;
      });
    }
    return promise;
  };

  // Also intercept jQuery $.ajax if jQuery is present
  if (window.jQuery) {
    jQuery(document).ajaxSuccess(function (event, xhr, settings) {
      if (settings.url && settings.url.indexOf('/cart/add') !== -1 &&
          (settings.type || '').toUpperCase() === 'POST') {
        var addedItem = null;
        try { addedItem = JSON.parse(xhr.responseText); } catch (e) {}
        document.dispatchEvent(new CustomEvent('slideout-cart:item-added', { detail: { item: addedItem } }));
      }
    });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  var SlideoutCart = {
    el: '#slideout-cart-app',
    delimiters: ['[[', ']]'],

    data: function () {
      // Free gift config is passed from theme settings via data attributes
      var root = document.getElementById('slideout-cart-app');
      var giftThreshold = parseInt(root && root.getAttribute('data-free-gift-threshold'), 10) || 0;

      return {
        giftThreshold: giftThreshold,
        giftLabel: (root && root.getAttribute('data-free-gift-label')) || 'Free Gift',
        open: false,
        loading: false,
        loaded: false,
        updatingKey: null,
        cart: {
          items: [],
          total_price: 0,
          item_count: 0
        }
      };
    },

    computed: {
      subtotal: function () {
        return formatMoney(this.cart.total_price);
      },

      shippingThreshold: function () {
        return 9900; // $99.00 in cents
      },

      shippingAmountLeft: function () {
        return Math.max(0, this.shippingThreshold - this.cart.total_price);
      },

      shippingAmountLeftFormatted: function () {
        return formatMoney(this.shippingAmountLeft);
      },

      // Gift tier only applies when it sits above the free shipping threshold
      giftEnabled: function () {
        return this.giftThreshold > this.shippingThreshold;
      },

      giftAmountLeft: function () {
        return Math.max(0, this.giftThreshold - this.cart.total_price);
      },

      giftAmountLeftFormatted: function () {
        return formatMoney(this.giftAmountLeft);
      },

      // Bar spans up to the highest active milestone
      progressMax: function () {
        return this.giftEnabled ? this.giftThreshold : this.shippingThreshold;
      },

      shippingProgress: function () {
        return Math.min(100, Math.round((this.cart.total_price / this.progressMax) * 100));
      },

      shippingMarkerPosition: function () {
        return (this.shippingThreshold / this.progressMax) * 100;
      }
    },

    methods: {
      openCart: function () {
        if (!this.loaded) this.fetchCart();
        this.open = true;
        document.body.style.overflow = 'hidden';
      },

      closeCart: function () {
        this.open = false;
        document.body.style.overflow = '';
      },

      fetchCart: function (silent) {
        var self = this;
        if (!silent) self.loading = true;
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            self.cart = data;
            self.loading = false;
            self.loaded = true;
          })
          .catch(function () { self.loading = false; });
      },

      updateQuantity: function (key, newQty) {
        var self = this;
        self.updatingKey = key;
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            self.cart = data;
            self.updatingKey = null;
            self._syncHeaderCount(data.item_count);
          })
          .catch(function () { self.updatingKey = null; });
      },

      removeItem: function (key) {
        this.updateQuantity(key, 0);
      },

      increment: function (item) {
        this.updateQuantity(item.key, item.quantity + 1);
      },

      decrement: function (item) {
        if (item.quantity <= 1) {
          this.removeItem(item.key);
        } else {
          this.updateQuantity(item.key, item.quantity - 1);
        }
      },

      itemPrice: function (item) {
        return formatMoney(item.final_line_price);
      },

      hasDiscount: function (item) {
        return item.original_line_price > item.final_line_price;
      },

      comparePrice: function (item) {
        return formatMoney(item.original_line_price);
      },

      savingsAmount: function (item) {
        return formatMoney(item.original_line_price - item.final_line_price);
      },

      itemImage: function (item) {
        if (!item.image) return 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png';
        return item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x120$1$2');
      },

      injectItem: function (addedItem) {
        // /cart/add.js returns a single item or { items: [...] } for multi-add
        var newItems = addedItem.items || [addedItem];
        var cart = this.cart;
        newItems.forEach(function (newItem) {
          var existing = cart.items.find(function (i) { return i.key === newItem.key; });
          if (existing) {
            existing.quantity = newItem.quantity;
            existing.final_line_price = newItem.final_line_price;
          } else {
            cart.items.unshift(newItem);
          }
        });
        // Recalculate totals optimistically
        cart.item_count = cart.items.reduce(function (sum, i) { return sum + i.quantity; }, 0);
        cart.total_price = cart.items.reduce(function (sum, i) { return sum + i.final_line_price; }, 0);
        this._syncHeaderCount(cart.item_count);
        this.loaded = true;
      },

      _syncHeaderCount: function (count) {
        var els = document.querySelectorAll('.cart-qty');
        els.forEach(function (el) { el.textContent = count; });
      }
    },

    mounted: function () {
      var self = this;

      // Pre-fetch cart silently on page load so data is ready before user opens
      self.fetchCart(true);

      // Listen for custom event to open cart
      document.addEventListener('slideout-cart:open', function () {
        self.openCart();
      });

      // Fired by the global fetch interceptor on any successful /cart/add.js call
      document.addEventListener('slideout-cart:item-added', function (e) {
        var addedItem = e.detail && e.detail.item;
        if (addedItem) {
          self.injectItem(addedItem);
        }
        self.open = true;
        document.body.style.overflow = 'hidden';
        // Background sync to get accurate totals/discounts
        self.fetchCart(true);
      });


      // Keyboard: close on Escape
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.open) self.closeCart();
      });

      // Header cart icon — open slideout instead of dropdown
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.icon-cart-header');
        if (trigger) {
          e.preventDefault();
          e.stopPropagation();
          self.openCart();
        }
      });
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('slideout-cart-app') && window.location.pathname !== '/cart') {
      new Vue(SlideoutCart);
    }
  });

  // Expose helper so other scripts can open the cart
  window.slideoutCart = {
    open: function () {
      document.dispatchEvent(new CustomEvent('slideout-cart:open'));
    }
  };
})();
